export const fetchClassRoomImportantPostsReducer = (state, action) => {
  switch (action.status) {
    case 'success': {
      const actionImportantPosts = action.importantPosts;
      const importantPostIds = [];
      const statePosts = { ...state.posts };
      actionImportantPosts.forEach((post) => {
        importantPostIds.push(post.objectId);

        if (!statePosts[post.objectId]) {
          statePosts[post.objectId] = {
            ...post,
            comments: [],
            tags: [],
          };
        }
      });

      const classRooms = { ...state.classRooms };
      if (actionImportantPosts.length > 0) {
        const classRoomId = actionImportantPosts[0].classRoom;
        const classRoom = classRooms[classRoomId];
        const classRoomPosts = [
          ...new Set([...classRoom.posts, ...importantPostIds]),
        ];

        classRooms[classRoomId] = {
          ...classRoom,
          posts: classRoomPosts,
        };
      }

      return {
        ...state,
        posts: statePosts,
        classRooms,
      };
    }
    case 'error':
      return {
        ...state,
      };

    default:
      return state;
  }
};

export const setPostImportantReducer = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isUpdatingPost: true,
      };
    case 'success': {
      const { importantPost } = action;
      const spaceId = importantPost.classRoom;
      const postId = importantPost.objectId;

      const statePost = state.posts[postId];
      const statePosts = {
        ...state.posts,
        [postId]: {
          ...statePost,
          important: true,
        },
      };

      const currentImportantPostCount =
        state.classRooms[spaceId].importantPostCount;
      const stateClassRooms = {
        ...state.classRooms,
        [spaceId]: {
          ...state.classRooms[spaceId],
          importantPostCount: currentImportantPostCount
            ? currentImportantPostCount + 1
            : 1,
        },
      };

      return {
        ...state,
        posts: statePosts,
        classRooms: stateClassRooms,
        isUpdatingPost: false,
      };
    }
    case 'error':
      return {
        ...state,
        isUpdatingPost: false,
      };

    default:
      return {
        ...state,
        isUpdatingPost: false,
      };
  }
};

export const unsetPostImportantReducer = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isUpdatingPost: true,
      };
    case 'success': {
      const statePosts = { ...state.posts };
      const actionImportantPost = action.importantPost;

      statePosts[actionImportantPost.objectId].important = false;

      const spaceId = actionImportantPost.classRoom;

      const stateClassRooms = {
        ...state.classRooms,
        [spaceId]: {
          ...state.classRooms[spaceId],
          importantPostCount: state.classRooms[spaceId].importantPostCount - 1,
        },
      };

      return {
        ...state,
        posts: statePosts,
        classRooms: stateClassRooms,
        isUpdatingPost: false,
      };
    }
    case 'error':
      return {
        ...state,
        isUpdatingPost: false,
      };

    default:
      return {
        ...state,
        isUpdatingPost: false,
      };
  }
};
